import React, { useEffect } from "react";
import { toast } from "sonner";
import { MapPin, Phone, Instagram, MessageCircle, Copy } from "lucide-react";
import { STORE, waLink } from "@/lib/store";

export default function Contact() {
  useEffect(() => {
    document.title = "Contact | Knoble Rides Bicycle Store Mangoro Lagos Nigeria";
  }, []);

  const copyPhone = () => {
    navigator.clipboard?.writeText(STORE.phoneRaw);
    toast.success("Phone number copied", { description: STORE.phoneDisplay });
  };

  return (
    <div>
      <section className="bg-[#0B0A09] py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <span className="kn-overline text-[#e0b48a]">Get In Touch</span>
          <h1 className="mt-3 font-display text-4xl font-extrabold text-white sm:text-5xl">Contact Us</h1>
          <p className="mt-4 max-w-2xl text-lg text-zinc-300">
            The fastest way to reach us is WhatsApp. Call, message, or visit our store in Mangoro, Lagos.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-2">
          <div className="space-y-5">
            <div className="rounded-2xl border border-[#E6D7C8] bg-white p-6">
              <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#25D366]/10">
                  <MessageCircle className="h-6 w-6 text-[#25D366]" />
                </div>
                <div className="flex-1">
                  <h3 className="font-display text-lg font-bold text-[#0B0A09]">WhatsApp</h3>
                  <p className="mt-1 text-sm text-zinc-500">Quick replies with availability & pickup info.</p>
                  <a
                    href={waLink(`Hello ${STORE.name}, I'd like to enquire about your bikes.`)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-wa mt-4 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-bold"
                  >
                    <MessageCircle className="h-4 w-4" /> Chat Now
                  </a>
                </div>
              </div>
            </div>

            <div className="rounded-2xl border border-[#E6D7C8] bg-white p-6">
              <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#FDF8F3]">
                  <Phone className="h-6 w-6 text-[#8C5A32]" />
                </div>
                <div className="flex-1">
                  <h3 className="font-display text-lg font-bold text-[#0B0A09]">Call Us</h3>
                  <a href={STORE.phoneTel} data-testid="contact-phone-link" className="mt-1 block text-lg font-semibold text-[#8C5A32] hover:underline">
                    {STORE.phoneDisplay}
                  </a>
                  <button onClick={copyPhone} className="mt-3 inline-flex items-center gap-1.5 rounded-full border border-[#E6D7C8] px-4 py-2 text-xs font-semibold text-zinc-600 hover:bg-[#FDF8F3]">
                    <Copy className="h-3.5 w-3.5" /> Copy number
                  </button>
                </div>
              </div>
            </div>

            <div className="rounded-2xl border border-[#E6D7C8] bg-white p-6">
              <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#FDF8F3]">
                  <Instagram className="h-6 w-6 text-[#8C5A32]" />
                </div>
                <div className="flex-1">
                  <h3 className="font-display text-lg font-bold text-[#0B0A09]">Instagram</h3>
                  <a href={STORE.instagramUrl} target="_blank" rel="noopener noreferrer" data-testid="contact-instagram-link" className="mt-1 block text-lg font-semibold text-[#8C5A32] hover:underline">
                    {STORE.instagram}
                  </a>
                </div>
              </div>
            </div>

            <div className="rounded-2xl border border-[#E6D7C8] bg-white p-6">
              <div className="flex items-start gap-4">
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#FDF8F3]">
                  <MapPin className="h-6 w-6 text-[#8C5A32]" />
                </div>
                <div className="flex-1">
                  <h3 className="font-display text-lg font-bold text-[#0B0A09]">Visit Our Store</h3>
                  <p className="mt-1 text-sm text-zinc-600">{STORE.address}</p>
                  <a
                    href={STORE.directionsUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="contact-get-directions"
                    className="btn-brown mt-4 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-bold"
                  >
                    <MapPin className="h-4 w-4" /> Get Directions
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="overflow-hidden rounded-2xl border border-[#E6D7C8] shadow-sm">
            <iframe title="Knoble Rides store location" src={STORE.mapEmbedUrl} className="h-full min-h-[520px] w-full" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
          </div>
        </div>
      </section>
    </div>
  );
}
